import {Request} from "../../request.abstract";
import {Observable} from "rxjs/Observable";
import {Permission} from "../../permissions/api.models";
import {Settings} from "../../settings.model";
import {Http} from "@angular/http";

export class PermissionsEndpoint extends Request {
    protected roleId: number;

    constructor(http: Http, settings: Settings, roleId: number) {
        super(http, settings);

        this.roleId = roleId;
    }

    collection(): Observable<Permission[]> {
        return this.get('/v1/roles/' + this.roleId + '/permissions');
    }

    grant(permissionId: number): Observable<Boolean> {
        return this.get('/v1/roles/' + this.roleId + '/permissions/' + permissionId);
    }

    revoke(permissionId: number): Observable<Boolean> {
        return this.delete('/v1/roles/' + this.roleId + '/permissions/' + permissionId);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/roles/permissions/api.service.ts